module.exports = __webpack_public_path__ + "static/media/POOSTRAS_MENU-normal.2758e3be.png";